import { render, staticRenderFns } from "./self.vue?vue&type=template&id=bd482d56&scoped=true&"
import script from "./self.vue?vue&type=script&lang=js&"
export * from "./self.vue?vue&type=script&lang=js&"
import style0 from "./self.vue?vue&type=style&index=0&id=bd482d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd482d56",
  null
  
)

export default component.exports